module.exports = __webpack_public_path__ + "static/media/icon-dynamic-segment-grey.391a8fe2.svg";